/** @jsxImportSource @emotion/react */
import { Chip } from "@mui/material";
import PropTypes from "prop-types";
import { BID_SCHEDULED_STATUS } from "../../util/bid/bidConstants";

const BidScheduledStatusChip = (props) => {
  const renderScheduledStatusChip = () => {
    switch (props.scheduledStatus) {
      case BID_SCHEDULED_STATUS.NOT_SCHEDULED:
        return (
          <Chip
            sx={{
              backgroundColor: "primary.swaYellow",
              color: "secondary.swaBlack",
              width: "120px",
              borderRadius: "5px",
            }}
            label={BID_SCHEDULED_STATUS.NOT_SCHEDULED}
            // size="small"
          ></Chip>
        );
      case BID_SCHEDULED_STATUS.SCHEDULED:
        return (
          <Chip
            sx={{
              backgroundColor: "secondary.swaGreen",
              color: "secondary.swaWhite",
              width: "120px",
              borderRadius: "5px",
            }}
            label={BID_SCHEDULED_STATUS.SCHEDULED}
            // size="small"
          ></Chip>
        );
      case BID_SCHEDULED_STATUS.DELAYED:
        return (
          <Chip
            sx={{ backgroundColor: "primary.swaRed", color: "secondary.swaWhite", width: "120px", borderRadius: "5px" }}
            label={BID_SCHEDULED_STATUS.DELAYED}
            // size="small"
          ></Chip>
        );
      case "":
        return "";
      default:
        return "Error";
    }
  };

  return renderScheduledStatusChip();
};

BidScheduledStatusChip.propTypes = {
  scheduledStatus: PropTypes.string.isRequired,
};

export default BidScheduledStatusChip;
